import { Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  getActiveLanguage,
  getLanguageHomePath,
} from '../../helpers/homepageUrl';

const RedirectToInitialPage = () => {
  const { pathname } = useLocation();
  const locale = useSelector((state) => state.intl.locale);
  const language = getActiveLanguage(pathname, locale);

  return <Redirect to={getLanguageHomePath(language)} />;
};

export default RedirectToInitialPage;
